// extracted by mini-css-extract-plugin
export default {"cardMinHeight":"tiles_cardMinHeight__PgKqG"};